export default "__VITE_ASSET__Du5f3n$k__"